import { styled } from 'twin.macro'
import typographyStyle from './styles'

const Typography = styled.span(typographyStyle)

export default Typography
